// extracted by mini-css-extract-plugin
module.exports = {"only_mobile":"_93444fe79c--only_mobile--Ms_c3","only_tablet":"_93444fe79c--only_tablet--t4kE8","only_desktop":"_93444fe79c--only_desktop--B0ZIy"};